
/**
 * custom-slider
 * Slider component
*/

let productGallerySlider;
let featuredCollectionsSlider;
var allSliderInstance = [];
class customSlider extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper');
    this.swiperDistroyMedia = this.querySelector('[data-swiper-distroy]');
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let isGridStyleSlider = false;
    this.sliderOptions = this.sliderEle.getAttribute('data-slider-options');
    this.sliderOptions = JSON.parse(this.sliderOptions);
    if(this.sliderOptions.pagination){
      this.sliderOptions.pagination.renderBullet = function (index, className) {
        return `<span class="${className} swiper-pagination-bullet--svg-animation"><svg width="20" height="20" viewBox="0 0 28 28"><circle class="svg__circle" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle><circle class="svg__circle-inner" cx="14" cy="14" r="5" stroke-width="2"></circle></svg></span>`;
      };
    }
    this.sliderOptions.resizeObserver = true;
    this.sliderInstance = '';

    if(this.sliderEle.hasAttribute('slider-thumbslider')){
      let navSlider = document.querySelector('.' + this.sliderEle.getAttribute('slider-thumbslider'));
      if(!navSlider){
        return;
      }
      let navSliderOptions = navSlider.getAttribute('data-slider-options');
      navSliderOptions = JSON.parse(navSliderOptions);
      navSlider = new Swiper(navSlider, navSliderOptions);

      this.sliderOptions.thumbs = {
        swiper: navSlider
      }

    }

    this.sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);
    var sectionId = this.closest('.shopify-section')?.getAttribute('id');
    allSliderInstance[sectionId] = this.sliderInstance;
    if (this.sliderEle.classList.contains('product-media-gallery-slider')) {
      productGallerySlider = this.sliderInstance;
    }

    
    if(this.closest('.section-slideshow')) {
      this.sliderInstance.on('slideChange', function () {
        // Get all slides
        const slides = this.slides;
  
        // Loop through each slide
        slides.forEach(slide => {
          // Find all elements with the data-sk-animation attribute inside the slide
          const animatedElements = slide.querySelectorAll('[data-sk-animation]');
          
          animatedElements.forEach(el => {
            // Remove the sk-animated class from all elements in every slide
            el.classList.remove('sk-animated');
          });
        });
  
        // Find the active slide
        const activeSlide = slides[this.activeIndex]; 
        
        // Find all elements with the data-sk-animation attribute inside the active slide
        const animatedElements = activeSlide.querySelectorAll('[data-sk-animation]');
        
        animatedElements.forEach(el => {
          const delay = el.getAttribute('data-sk-animation-delay') || 0;
          
          setTimeout(() => {
            // Add the sk-animated class to the elements in the active slide
            el.classList.add('sk-animated');
          }, delay);
        });
      });
    }
    

    this.sliderEle.getAttribute('data-layout-grid') == 'true' && (isGridStyleSlider = true);

    if (isGridStyleSlider) {
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 992) {
          productGallerySlider.destroy();
        } else {
          productGallerySlider = new Swiper(this.sliderEle, this.sliderOptions);
        }
      })  
    }

    if (this.sliderEle.classList.contains('feature-collections') && (
      !this.sliderEle.classList.contains('desktop-slider') || !this.sliderEle.classList.contains('mobile-slider')
    )) {
      featuredCollectionsSlider = this.sliderInstance;
      if (this.sliderEle.classList.contains('desktop-slider')) {
        if (window.innerWidth < 576) { featuredCollectionsSlider.destroy(); }
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 576) {
            featuredCollectionsSlider = new Swiper(this.sliderEle, this.sliderOptions);
          } else {
            featuredCollectionsSlider.destroy();
          }
        }) 
      } else if (this.sliderEle.classList.contains('mobile-slider')) {
        if (window.innerWidth >= 576) { featuredCollectionsSlider.destroy(); }
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 576) {
            featuredCollectionsSlider.destroy();
          } else {
            featuredCollectionsSlider = new Swiper(this.sliderEle, this.sliderOptions);
          }
        }) 
      }
    }

    if(this.swiperDistroyMedia) {
      this.manageResizeSlider();
      window.addEventListener('resize', () => {
        this.manageResizeSlider();
      })
    }
  }

  /**
   * distroy swiper slide on certian media query
   * @param sliderToDisplay media query to display slider from
   */
  manageResizeSlider() {
    const debouncedCheck = Utility.debounce((e) => {
      if (window.matchMedia(this.swiperDistroyMedia.dataset.swiperDistroy).matches) {
        this.sliderInstance.destroy();
      } else {
        var sectionId = this.closest('.shopify-section')?.getAttribute('id');
        allSliderInstance[sectionId] = this.sliderInstance;
        this.sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);
      }
    }, 500);
    debouncedCheck();
  }
}
customElements.define('custom-slider', customSlider);